jQuery(document).ready(function ($) {

    $('.faq__item, .accordeon__item').on('click', '.main-title', function () {
        $(this)
            .toggleClass('active')
            .next()
            .stop().slideToggle();
    });

    $('.faq-categories li').on('click', function () {
        var id = $(this).data('id');
        $('.faq-categories li').removeClass('active');
        $('.category-section').removeClass('active');
        $('.category-section[data-id="' + id + '"]').addClass('active');
        $(this).addClass('active');
        $('.faq-info-title').hide();
    });

    if ($(window).width() < 993) {
        $('.categories__item').click(function () {
            $('html, body').animate({
                scrollTop: $('.faq-overview__sections').offset().top - 100
            }, 600);
        });
    }

    function openFaqFromHash() {
        var hash = window.location.hash || '';
        if (!/^#faq-\d+$/.test(hash)) return;

        var $item = $(hash);
        if ($item.length === 0) return;

        var categoryId = $item.closest('.category-section').data('id');
        if (!categoryId) return;

        $('.faq-categories li[data-id="' + categoryId + '"]').trigger('click');

        var $mainTitle = $item.find('.main-title').first();
        if (!$mainTitle.hasClass('active')) {
            $mainTitle.trigger('click');
        }

        setTimeout(function () {
            $item[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, $.fx.speeds._default + 50);
    }

    openFaqFromHash();
    $(window).on('hashchange', openFaqFromHash);
});
